module.exports = __webpack_public_path__ + "static/media/carbon_circle-dash.eb63933a.svg";